/** EPOS staff activity ActionType → display label */
const ACTION_LABELS = {
  LOGIN: "Login",
  LOGOUT: "Logout",
  OPEN_SETTINGS: "Open settings",
  OPEN_PRINTER_SETTINGS: "Open printer settings",
  OPEN_SALE_REPORT: "Open sale report",
  OPEN_GENERAL_REPORT: "Open general report",
  SETTINGOPEN: "Open settings",
};

export const STAFF_ACTIVITY_ACTION_OPTIONS = [
  { value: "all", label: "All actions" },
  { value: "LOGIN", label: "Login" },
  { value: "LOGOUT", label: "Logout" },
  { value: "OPEN_SETTINGS", label: "Open settings" },
  { value: "OPEN_PRINTER_SETTINGS", label: "Open printer settings" },
  { value: "OPEN_SALE_REPORT", label: "Open sale report" },
  { value: "OPEN_GENERAL_REPORT", label: "Open general report" },
];

export function formatStaffActivityAction(actionType) {
  if (actionType == null || actionType === "") return "";
  const key = String(actionType).trim().toUpperCase().replace(/\s+/g, "_");
  if (ACTION_LABELS[key]) return ACTION_LABELS[key];
  if (key === "SETTINGSOPEN") return ACTION_LABELS.SETTINGOPEN;
  return String(actionType)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
